import { I18n } from '@calendly/i18n';
import { Banner } from '@calendly/ui/components/banner';
import { Button } from '@calendly/ui/components/button';
import { IconCurrencyDollar } from '@calendly/ui/components/glyphs/IconCurrencyDollar';
import { BodyText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { colorSurfaceActionMeetingIntelligence } from '@calendly/ui/theme';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade';
import { isEnterpriseSelector } from 'features/billing';
import { useTrack, TRACKING_EVENT_NAMES } from 'hooks/analytics_events';

// NOTE: Using `type="meeting_intelligence"` to avoid the default border color.
//
// see https://github.com/calendly/ui/blob/f0e048d88d86d455c360923c3ef4326d5d497707/src/components/banner/banner.tsx#L23-L73
//
const meetingIntelligenceBannerCss = "m7a9587";
const MeetingIntelligenceBanner = forwardRef((props, ref) => {
  const type = 'meeting_intelligence';
  return <Banner ref={ref} {...props} type={type} className={classNames(meetingIntelligenceBannerCss, props.className)} />;
});
const contentIsDesktopUpCss = "czo34h7";
const contentCss = "ct7orqa";
const Content = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isDesktopUp = useDeviceType('isDesktopUp');
  return <Component ref={ref} {...restProps} className={classNames(contentCss, {
    [contentIsDesktopUpCss]: isDesktopUp
  }, props.className)} />;
});
const iconAndTextWrapperCss = "i1azcfl2";
const IconAndTextWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconAndTextWrapperCss, props.className)} />;
});
const trackCTAShown = track => {
  track({
    name: TRACKING_EVENT_NAMES.CTA_SHOWN,
    entities: ['attribution', 'organization', 'user'],
    properties: {
      cta_destination: 'ai_paywall',
      cta_key: 'recaps',
      cta_text: 'upgrade'
    }
  });
};
const trackCTAClicked = track => {
  track({
    name: TRACKING_EVENT_NAMES.CTA_CLICKED,
    entities: ['attribution', 'organization', 'user'],
    properties: {
      cta_destination: 'ai_paywall',
      cta_key: 'recaps',
      cta_text: 'upgrade',
      action: 'interaction'
    }
  });
};
export const PaywallBanner = ({
  featureKey
}) => {
  const isEnterprise = useSelector(isEnterpriseSelector);
  const enforceUpgrade = useEnforceUpgrade(featureKey);
  const track = useTrack();
  useEffect(() => {
    trackCTAShown(track);
  }, [track]);
  const onClick = () => {
    enforceUpgrade();
    trackCTAClicked(track);
  };
  if (isEnterprise) {
    return <MeetingIntelligenceBanner>
        <Content>
          <IconAndTextWrapper>
            <UiIcon icon={IconCurrencyDollar} size="small" color={colorSurfaceActionMeetingIntelligence} title="" />
            <BodyText>
              {I18n.t('publisher.billing.meeting_intelligence.recap_upgrade_paywall_notice_enterprise')}
            </BodyText>
          </IconAndTextWrapper>
        </Content>
      </MeetingIntelligenceBanner>;
  }
  return <MeetingIntelligenceBanner>
      <Content>
        <IconAndTextWrapper>
          <UiIcon icon={IconCurrencyDollar} size="small" color={colorSurfaceActionMeetingIntelligence} title="" />
          <BodyText>
            {I18n.t('publisher.billing.meeting_intelligence.recap_upgrade_paywall_notice')}
          </BodyText>
        </IconAndTextWrapper>

        <Button onClick={onClick} decoration="meeting-intelligence">
          {I18n.t('publisher.billing.meeting_intelligence.explore_calendlys_ai_plan')}
        </Button>
      </Content>
    </MeetingIntelligenceBanner>;
};

require("./paywall_banner.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./paywall_banner.js");